const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassportCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.393,
    height: 27.195,
    viewBox: "0 0 34.393 27.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1812"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2225",
    d: "M35.393 26.6V12.2a3.6 3.6 0 0 0-3.6-3.6H27.3a1.8 1.8 0 0 1-1.8-1.8A1.8 1.8 0 0 0 23.7 5h-9a1.8 1.8 0 0 0-1.8 1.8 1.8 1.8 0 0 1-1.8 1.8H6.6A3.6 3.6 0 0 0 3 12.2v14.4a3.6 3.6 0 0 0 3.6 3.6h25.194a3.6 3.6 0 0 0 3.599-3.6z",
    transform: "translate(-2 -4)",
    style: {
      strokeWidth: 2,
      fill: "#aadbb0",
      stroke: "#aadbb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2226",
    d: "M18.1 14.549A4.549 4.549 0 1 1 13.549 10a4.549 4.549 0 0 1 4.551 4.549z",
    transform: "translate(3.648 1.16)",
    style: {
      fill: "none",
      stroke: "#dcefdf",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportCamera);
export default __webpack_public_path__ + "static/media/passportCamera.b490d813813ee4feb4f8a3a84082a364.svg";
export { ForwardRef as ReactComponent };